import React from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  description,
  children
}: PageHeaderProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-85">
      <div data-id="element-86">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" data-id="element-87">
          {title}
        </h1>
        {description && <p className="text-sm text-slate-500 mt-1" data-id="element-88">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2" data-id="element-89">{children}</div>}
    </div>;
}